// extracted by mini-css-extract-plugin
module.exports =  {"ModalInsertLink":"UqEMyDE0iWexY5ENIeNZ","ModalInsertLink__Save":"wjUsViflVKlQ0JdaLXwI","ModalInsertLink__Message":"IQSxcjDIEb9gXQgZ3h47"};